import { useMutation } from '@tanstack/react-query';

import { ENDPOINTS } from '@/api/endpoints';
import { fetchClient } from '@/api/fetch-client';
import {
  StructuredObservationApplyError,
  StructuredObservationApplyRequest,
  StructuredObservationApplyResponse,
} from '@/api/model';

const request = {
  postStructuredObservationApply: async ({ payload }: StructuredObservationApplyRequest) => {
    const { data } = await fetchClient.FCT.post<StructuredObservationApplyResponse>(
      ENDPOINTS.FCT.STRUCTURED_OBSERVATION.APPLY,
      { body: payload },
    );

    return data;
  },
};

const mutation = {
  usePostStructuredObservationApply: () =>
    useMutation<
      StructuredObservationApplyResponse,
      StructuredObservationApplyError,
      StructuredObservationApplyRequest
    >({
      mutationFn: request.postStructuredObservationApply,
    }),
};

export const structuredObservation = {
  mutation,
  request,
};
